<!-- eslint-disable vuejs-accessibility/anchor-has-content -->
<template>
  <div class="profile__wrapper">
    <div
      v-if="partnerLogo"
      class="profile-content__wrapper"
    >
      <div class="profile-content full-size">
        <partner-card
          class="profile-card"
          :photo="partnerLogo"
        />
      </div>
    </div>
    <div
      v-if="isPartnerContacts"
      class="profile-content__wrapper"
    >
      <div class="profile-content full-size">
        <div
          class="hot-link-panel"
          :class="{'scroll-panel': partnerContactsLength > 3}"
          >
          <div
            v-if="partnerStand || isMM || isMessenger"
            class="row justify-content-evenly"
            >
            <div
              v-if="partnerStand"
              class="col"
            >
              <up-card
                :class="{'card-map-link': isLinkToMap, 'card-map-stand': !isLinkToMap}"
              >
                <router-link
                  v-if="isLinkToMap"
                  :to="{ name: 'mapView', params: { stand_id: partnerStand } }"
                  class="map-link"
                >
                  <div>
                    <i class="exu-marker" />
                  </div>
                  <div>
                    <strong>{{ $t('exhibitorProfile.stand') }} {{ partnerStand }}</strong>
                  </div>
                </router-link>
                <div
                  v-else
                  class="map-link"
                >
                  <div>
                    <span>{{ $t('exhibitorProfile.stand') }}</span>
                    <strong>{{ partnerStand }}</strong>
                  </div>
                </div>
              </up-card>
            </div>
            <div
              class="col-auto"
            >
              <button
                @click="markingCompany"
                :class="{ marked }"
                class="marked-profile"
              >
                <i :class="[marked ? 'exu-bookmark-check-fill' : 'exu-bookmark' ]"/>
              </button>
            </div>
            <div
              v-if="isMessenger"
              class="col"
            >
              <up-card
                @click.stop="getChatUuid"
              >
                <div class="hot-link">
                  <i class="exu-message-chat-square" />
                </div>
              </up-card>
            </div>
            <div
              v-if="isMM"
              class="col"
            >
              <up-card
              >
                <router-link
                  v-if="isMeetUuid"
                  :to="{ name: 'editMatch', params: { matchId: this.participant.meet_uuid } }"
                  class="hot-link"
                >
                  <i class="exu-user-meeting big-i"/>
                </router-link>
                <router-link
                  v-else
                  :to="{ name: 'newMatch', params: { participantID: this.partner.agent } }"
                  class="hot-link"
                >
                  <i class="exu-user-meeting big-i"/>
                </router-link>
              </up-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="profile-content__wrapper">
      <div class="profile-content">
        <h3 v-if="isPartnerContacts">
          {{ $t('exhibitorProfile.contacts') }}
        </h3>
        <div
          v-for="item in partnerContacts"
          :key="`tile-${item.id}`"
          class="profile-content__contact-detail"
        >
          <i :class="{
            'exu-global': item.type === 'site',
            'exu-phone-1': item.type === 'work' || item.type === 'mobile',
            'exu-at-sign': item.type === 'email',
            'exu-telegram-icon': item.type === 'telegram',
            'exu-whatsapp-icon': item.type === 'whatsapp',
          }"/>
          <a
            v-if="item.tile === 'site'"
            :href="`${item.value}`"
            target="_blank"
          >
            {{ item.text || item.value }}
          </a>
          <a
            v-if="item.tile === 'phone'"
            :href="`tel:${item.value}`"
          >
            {{ item.text || item.value }}
          </a>
          <a
            v-if="item.tile === 'email'"
            :href="`mailto:${item.value}`"
          >
            {{ item.text || item.value }}
          </a>
          <a v-if="item.tile === 'messenger'"
            :href="item.value"
          >
            {{ item.text || item.value }}
          </a>
        </div>
      </div>
    </div>
    <div
      v-if="rubrics"
      class="profile-content__wrapper"
    >
      <div
        ref="rubricContent"
        class="rubric-content"
        :class="{'show-rubrics': isShowRubrics}"
      >
        <template
          v-for="(rubric, rindex) of rubrics"
          :key="`r-${rindex}`"
        >
          <h3>
            {{ rubric.label_ru }}
          </h3>
          <div v-if="rubric.values">
            <template
              v-for="(sectionGroup, gindex) of rubric.values"
              :key="`sg-${gindex}`"
            >
              <h4 v-if="sectionGroup.values">
                {{ sectionGroup.label_ru }}
              </h4>
              <div
                v-else
                class="rubric-section__item"
              >
                {{ sectionGroup.label_ru }}
              </div>
              <div
                v-if="sectionGroup.values"
                class="rubric-section__group"
              >
                <template
                  v-for="(section, sindex) of sectionGroup.values"
                  :key="`s-${sindex}`"
                >
                  <div
                    :class="[section.values ? 'rubric-section__title' : 'rubric-section__item']"
                  >
                    {{ section.label_ru }}
                  </div>
                  <div
                    v-if="section.values"
                    class="rubric-section"
                  >
                    <template
                      v-for="(sectionItem, siindex) of section.values"
                      :key="`s-${siindex}`"
                    >
                      <div class="rubric-section__item">
                        {{ sectionItem.label_ru }}
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
    <div
      v-if="rubrics"
      class="profile-content__wrapper"
    >
      <div class="profile-content full-size">
        <button
          @click="rollRubricBlock()"
          class="up-btn up-btn-rubrics"
        >
          <template v-if="isShowRubrics">{{ $t('exhibitorProfile.hide_rubrics') }}</template>
          <template v-else>{{ $t('exhibitorProfile.show_all_rubrics') }}</template>
        </button>
      </div>
    </div>
    <div
      v-if="partnerDescription"
      class="profile-content__wrapper"
    >
      <div class="profile-content">
        <h3>
          {{ $t('exhibitorProfile.about_company_title') }}
        </h3>
        <div
          v-if="isHtmlFormat"
          class="html-description-styles"
          v-html="partnerDescription"
        />
        <p
          v-else
          class="description-paragraph"
        >
          {{ partnerDescription }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import appBaseNav from '@/components/mixins/appBaseNav';
import exhibitors from '@/components/mixins/methodsExhibitors';
import methodsChat from '@/components/mixins/methodsChat';
import methodsMeetings from '@/components/mixins/api/apiMethodsMeeting';

export default {
  name: 'ExhibitorProfile',
  mixins: [appBaseNav, exhibitors, methodsChat, methodsMeetings],
  props: {
    id: {
      type: String,
      requared: true,
    },
    locale: {
      type: String,
    },
  },
  data() {
    return {
      partner: null,
      showPopup: false,
      showType: null,
      marked: false,
      isShowRubrics: false,

      isLoading: true,
      isLinkToMap: false,
    };
  },
  computed: {
    togglePopup: {
      get() {
        return this.showPopup;
      },
      set([newState, setType = null]) {
        this.showPopup = newState;
        if (setType === 'work' || setType === 'mobile') this.showType = 'phone';
        else if (setType === 'telegram' || setType === 'whatsapp') this.showType = 'messenger';
        else this.showType = setType;
      },
    },
    partnerStand() {
      return this.partner?.stand || null;
    },
    partnerLogo() {
      return this.partner?.logo || null;
    },
    isPartnerContacts() {
      return this.partner?.contacts && Array.isArray(this.partner.contacts);
    },
    partnerContacts() {
      return this.partner?.contacts.map((item) => {
        let blockType;
        switch (item.type) {
          case 'work':
          case 'mobile':
          case 'fax':
            blockType = 'phone';
            break;
          case 'telegram':
          case 'whatsapp':
            blockType = 'messenger';
            break;
          default:
            blockType = item.type;
            break;
        }
        return {
          ...item, tile: blockType,
        };
      }) || [];
    },
    partnerContactsTile() {
      return this.partnerContacts.reduce((acc, item) => {
        if (acc.includes(item.tile)) {
          return acc;
        }
        return [...acc, item.tile];
      }, []);
    },
    partnerContactsLength() {
      // return this.partner?.contacts.length || 0;
      return this.partnerContactsTile.length || 0;
    },
    partnerDescription() {
      return this.partner?.description || null;
    },
    getContactType() {
      switch (this.showType) {
        case 'site':
          return this.partnerContacts
            .filter((item) => item.tile === 'site')
            .map((item) => ({ ...item, value: item.value.replace(/https:\/\/|http:\/\//g, '') }));
        default:
          return this.partnerContacts.filter((item) => item.tile === this.showType);
      }
    },
    isTextFormat() {
      return this.partner.description_format === 'text';
    },
    isHtmlFormat() {
      return this.partner.description_format === 'html';
    },
    isMeetUuid() {
      return this.isMM && this.partner.meet_uuid;
    },
    getAgent() {
      return this.partner?.agent || null;
    },
    isMM() {
      return this.$store.getters.isPartnersMM && !!this.getAgent;
    },
    isMessenger() {
      return this.$store.getters.isMessenger && this.getAgent;
    },
    rubrics() {
      return this.partner?.rubrics || null;
    },
  },
  watch: {
    locale() {
      this.loadPage();
    },
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    loadPage() {
      this.$store.commit('setPageTitle', this.$t('exhibitorProfile.header_title'));
      this.getExhibitorPersone(this.id)
        .then((exhibitor) => {
          this.partner = { ...exhibitor };
          this.isLoading = false;

          return this.partner.stand ? this.getExhibitorByStand(this.partner.stand) : null;
        })
        .then((stand) => {
          if (stand !== null) this.isLinkToMap = true;
          this.loadMarkedExhibitors();
          return this.partner.participant_id
            ? this.getMeetingByUser(this.partner.participant_id) : null;
        })
        .then((result) => {
          const MEET = Array.isArray(result) && result[0] ? result[0] : null;
          if (MEET && MEET.uuid) {
            this.partner.meet_uuid = MEET.uuid;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getChatUuid() {
      if (this.partner.participant_id) {
        this.getChatRoomByUser(this.partner.participant_id)
          .then((results) => {
            this.$router.push({ name: 'chatView', params: { uuid: results.uuid } });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    loadMarkedExhibitors() {
      const exhID = this.$store.getters.getExhId;
      const markedList = localStorage.getItem(`exh-${exhID}-marked`);
      if (markedList === null) {
        localStorage.setItem(`exh-${exhID}-marked`, JSON.stringify([]));
      } else {
        JSON.parse(markedList).forEach((item) => {
          if (item.type === 'exhibitors' && item.id === parseInt(this.id, 10)) {
            this.marked = true;
          }
        });
      }
    },
    markingCompany() {
      const exhID = this.$store.getters.getExhId;
      const JsonMarkedList = localStorage.getItem(`exh-${exhID}-marked`);
      const markedList = JSON.parse(JsonMarkedList);
      console.log(markedList);

      const companyID = parseInt(this.id, 10);
      // const company = this.exhibitorsList.find((companyItem) => companyItem.id === companyID);
      const markedCompany = markedList.findIndex((companyItem) => companyItem.id === companyID);

      if (markedCompany === -1) {
        markedList.push({
          type: 'exhibitors',
          id: companyID,
        });
      } else {
        markedList.splice(markedCompany, 1);
      }

      localStorage.setItem(`exh-${exhID}-marked`, JSON.stringify(markedList));
      // не нашли и добавили, по этому результат поиска -1
      this.marked = markedCompany === -1;
    },
    rollRubricBlock() {
      console.log('111');
      this.isShowRubrics = !this.isShowRubrics;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.profile__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  min-height: 100%;
  padding-top: 16px;
  padding-bottom: 24px;
}
.profile-content__wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
}
.profile-content {
  display: flex;
  padding: 0px 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  &.full-size {
    width: 100%;
  }

  .description-paragraph {
    color: $color-disabled;
    // font-family: Roboto;
    // font-size: 14px;
    text-align: justify;
    margin: 0;
  }

  .logo-item > img {
    max-height: 44px;
  }

  .hot-link-panel {
    width: 100%;
    color: $color-text;

    &.scroll-panel {
      overflow-x: scroll;

      &::-webkit-scrollbar {
        width: 0px;
        height: 0px;               /* width of the entire scrollbar */
      }
      &:focus::-webkit-scrollbar {
        width: 4px;
        height: 4px;               /* width of the entire scrollbar */
      }

      &::-webkit-scrollbar-track {
        background: rgba($color-primary, 0);        /* color of the tracking area */
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba($color-primary, 0);    /* color of the scroll thumb */
        border-radius: 2px;       /* roundness of the scroll thumb */
        border: none;  /* creates padding around scroll thumb */
      }
      &:focus::-webkit-scrollbar-track {
        background: rgba($color-primary, .25);        /* color of the tracking area */
      }

      &:focus::-webkit-scrollbar-thumb {
        background-color: rgba($color-primary, .25);    /* color of the scroll thumb */
        border-radius: 2px;       /* roundness of the scroll thumb */
        border: none;  /* creates padding around scroll thumb */
      }
      .row {
        flex-wrap: nowrap;
        padding-left: calc(var(--bs-gutter-x) * .25);
        padding-right: calc(var(--bs-gutter-x) * .25);

        &>* {
          width: 30%;
          padding-left: calc(var(--bs-gutter-x) * .25);
          padding-right: calc(var(--bs-gutter-x) * .25);
        }
      }
    }

    & .upCard {
      // border: 2px solid #1c1c1c;

      &.card-map-link {
        height: 50px;
        padding: 0 25px;
        border-radius: 25px;
        background: $color-primary;
        color: $color-base;
      }
      &.card-map-stand {
        border: 2px solid $color-disabled;

        .map-link {
          color: $color-disabled;
        }
      }
    }

    i {
      font-size: 20px;
    }
  }
  .map-link {
    display: flex;
    height: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 0;
    text-decoration: none;
    color: inherit;
    & > div {
      display: flex;
      height: 100%;
      flex-direction: column;
      gap: 5px;
      align-items: start;
      justify-content: center;

      & span {
        font-size: .8rem;
        line-height: 1em;
      }
      & strong {
        font-size: 16px;
        line-height: 1em;
      }
    }
  }
  .hot-link {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    gap: 10px;
    padding: 12px 4px;
    text-decoration: none;
    color: $color-text;

    @media(max-width: 450px) {
      & {
        padding: 12px 0;
      }
    }

    .hot-link-text {
      @media(max-width: 450px) {
        & {
          display: none;
        }
      }

      display: block;
      font-size: 14px;
      line-height: 1.15em;
      color: $color-disabled;
      text-decoration: none;
      text-align: center;
    }

    & i {
      &.big-i {
        font-size: 2.4rem;
      }
    }
  }

  h3 {
    font-family: Roboto;
    font-weight: 700;
    font-size: 20px;
  }

  .stretch-link {
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }

  &__contact-detail {
    display: flex;
    align-items: center;
    gap: 10px;

    a {
      color: $color-text;
      text-decoration: underline;
    }
  }
  // как кнопки деловой программы: янтарная обводка, тёмное содержимое,
  // а отмеченная — янтарная заливка
  .marked-profile {
    display: flex;
    width: 3em;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: $color-primary;
    font-size: 20px;
    line-height: 20px;
    border: 2px solid $color-accent;
    border-radius: 25px;
    background-color: transparent;

    &.marked {
      background-color: $color-accent;
    }

    position: relative;
    z-index: 100;
  }
}
.contact-list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  gap: .4rem;
  list-style: none;

  & > li {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 16px;
    padding: 4px 0;
    font-size: 16px;
    line-height: 16px;
    color: $color-disabled;

    & > [class^="exu-"], [class*=" exu-"] {
      font-size: 1.5rem;
    }

    & > .contact-detail {
      display: flex;
      flex-direction: column;
      gap: .2rem;
      & > p {
        margin: 0;
      }
      & > a {
        color: $color-text;
      }
    }
  }
}
.rubric {
  &-content {
    display: flex;
    padding: 0px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    max-height: 220px;
    overflow: hidden;
    transition-property: max-height;
    transition-duration: .5s;
    transition-timing-function: linear;

    h3, h4 {
      font-family: Roboto;
      font-weight: 700;
      margin-bottom: 4px;
    }
    h3 {
      font-size: 20px;
    }
    h4 {
      font-size: 16px;
    }

    &.show-rubrics {
      max-height: none;
      // overflow: hidden scroll;
    }
  }
  &-section {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }

    &__item {
      flex: 0 1 auto;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      max-width: 100%;
      width: auto;
      height: auto;
      min-height: 30px;
      background: rgba($color-accent, .22);
      border: 2px solid rgba($color-accent, .5);
      border-radius: 20px;
      padding: 2px 15px;
      font-size: 14px;
      font-weight: 700;
      color: $color-primary;
    }

    &__title {
      font-weight: 700;
      margin-bottom: 2px;
    }
  }
  &-section__group {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
.up-btn-rubrics {
  width: 100%;
  text-align: center;
  text-decoration: none;
  border-radius: 25px;
  background: $color-primary;
  color: $color-base;
  border: none;
}
</style>
